module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_arrow_right-5d39cdab022ac0ae3ca157497633edc9.svg";